var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{staticClass:"bookmark",attrs:{"variant":"flat","size":"sm"},on:{"click":_vm.savePanel}},[(_vm.isSaved)?_c('b-icon',{attrs:{"icon":"bookmark-fill","variant":"primary"}}):_c('b-icon',{attrs:{"icon":"bookmark"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }